<template>
    <div>
        <vx-card title="View Schedule" subtitle="Lists of Generated Employee Schedule"  class="no-scroll-content" >
            <div class="vx-col w-full mb-base">
                <template>
                    <vs-table :data="getAllEmployeeSchedule" v-model="selected"    stripe pagination :max-items="10" search   >
                        <template slot="thead">
                            <vs-th sort-key="employeeCode">Code</vs-th>
                            <vs-th sort-key="fullName">Name</vs-th>
                            <vs-th sort-key="scheduleDate">Schedule Date</vs-th>
                            <vs-th>Day</vs-th>
                            <vs-th>Schedule In</vs-th>
                            <vs-th>Schedule Out</vs-th>
                            <vs-th>Shift Type</vs-th>
                            <vs-th>Schedule Type</vs-th>
                            <vs-th>Actions</vs-th>
                        </template>
                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="data[indextr].user.employeeCode">
                                    {{ data[indextr].user.employeeCode }}
                                </vs-td>
                                <vs-td :data="data[indextr].user.fullName">
                                    {{ data[indextr].user.fullName }}
                                </vs-td>
                                <vs-td :data="data[indextr].scheduleDate">
                                    {{ data[indextr].scheduleDate | fulldate }}
                                </vs-td>
                                <vs-td :data="data[indextr].scheduleDate">
                                    {{ getDayName(data[indextr].scheduleDate) }}
                                </vs-td>
                                <vs-td :data="data[indextr].scheduleIn">
                                    {{ data[indextr].scheduleIn | time }}
                                </vs-td>
                                <vs-td :data="data[indextr].scheduleOut">
                                    {{ data[indextr].scheduleOut | time }}
                                </vs-td>
                                <vs-td :data="data[indextr].shiftTypeId">
                                    {{ shiftTypeName(data[indextr].shiftTypeId).shiftTypeName }}
                                </vs-td>
                                <vs-td :data="data[indextr].scheduleTypeId">
                                    <span class="flex items-center px-2 py-1 rounded"><div v-bind:class="
                                    data[indextr].scheduleTypeId == 1 ? 'h-3 w-3 rounded-full mr-2 bg-success' :
                                    data[indextr].scheduleTypeId == 2 ? 'h-3 w-3 rounded-full mr-2 bg-danger' : 'h-3 w-3 rounded-full mr-2 bg-warning'"/>
                                    {{ scheduleTypeName(data[indextr].scheduleTypeId).scheduleTypeName}}
                                    </span>
                                </vs-td>
                                <vs-td>
                                    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                        <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                        <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].id)" />
                                    </div>
                                </vs-td>
                            </vs-tr>
                        </template>
                     </vs-table>
                </template>
            </div>
        </vx-card>
    </div>

    
</template>
<script>
import moment from 'moment'
export default {
    data() {
        return {
            selected: []

        }
    },
    created() {
        this.$store.dispatch('lookup/getAllShiftType').catch(err => { console.error(err) })
        this.$store.dispatch('lookup/getAllScheduleType').catch(err => { console.error(err) })
       
        this.getAllEmployeeSchedule = 1
    }, 
    computed: {
        getAllEmployeeSchedule : {
            get()  {  return this.$store.state.hrms.getAllEmployeeSchedule} ,
            set(val) {
                const data = {
                    createScheduleId: val, 
                    userId: this.$store.state.AppActiveUser.uid 
                }
                this.$store.dispatch('hrms/getAllEmployeeScheduleByCreateScheduleId', data)
            }
        },
        shiftTypeName() {
            return (shiftTypeId) => this.$store.getters['lookup/shiftTypeLookup'](shiftTypeId)
        },
        scheduleTypeName() {
            return (scheduleTypeId) => this.$store.getters['lookup/scheduleTypeLookup'](scheduleTypeId)
        },
        getDayName() {
            return (date) => moment(date).format('dddd')
        }
        
    }
}
</script>